/**
 * cache-utils.ts — Fonctions de nettoyage des caches localStorage par session.
 *
 * Centralise ici pour eviter les dependances circulaires (auth.tsx <-> hooks).
 * Chaque hook utilise un prefix commun ; les cles reelles sont suffixees par userId/teamId.
 */

const ONBOARDING_PREFIX = "s1_onboarding_completed";
const BRANDING_PREFIX = "s1_branding_onboarding_completed";
const TOUR_PREFIX = "s1_product_tour_completed";
// Couvre s1_nudge_* (dismiss/snooze/last_at) ET s1_nudges_enabled (préférence).
const NUDGE_PREFIX = "s1_nudge";

function clearByPrefix(prefix: string): void {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(prefix)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((k) => localStorage.removeItem(k));
}

export function clearOnboardingCache(): void {
  clearByPrefix(ONBOARDING_PREFIX);
}

export function clearBrandingOnboardingCache(): void {
  clearByPrefix(BRANDING_PREFIX);
}

export function clearTourCache(): void {
  clearByPrefix(TOUR_PREFIX);
}

export function clearNudgeCache(): void {
  clearByPrefix(NUDGE_PREFIX);
}

export function clearAllSessionCaches(): void {
  clearOnboardingCache();
  clearBrandingOnboardingCache();
  clearTourCache();
  clearNudgeCache();
}
